<template>
    <div class="container">
        <!-- <Breadcrumb class="bread_block" />  -->
        <CommonBreadcrumb class="bread_block" /> 
        <div class="banner text-center">
            <picture>
                <source media="(min-width: 768px)" width="1220" height="424" type="image/webp" srcset="~/assets/customize/banner.webp">
                <source media="(min-width: 768px)" width="1220" height="424" type="image/jpeg" srcset="~/assets/customize/banner.jpg">

                <source media="(max-width: 767px)" width="512" height="600" type="image/webp" srcset="~/assets/customize/banner_mobile.webp">
                <source media="(max-width: 767px)" width="512" height="600" type="image/jpeg" srcset="~/assets/customize/banner_mobile.jpg">
                <img width="1220" height="424" class="radious_eight" type="image/jpeg" src="~/assets/customize/banner.jpg" alt="Customize Your Jewelry">
            </picture>
        </div>
        <div class="for_mobile">
            <h1 class="font-active">{{ $t('customize') }} Your {{ $t('jewelry') }}</h1>
            <h2 class="mb-4">You Inspire, We Design!</h2>
            <p class="mb-0"><span class="ucfirst">{{ $t('customize') }}</span> {{ $t('jewelry') }} at Friendly Diamonds and bring your {{ $t('jewelry') }} design to life. Our teams of expert craftsmen create your bespoke {{ $t('jewelry') }} exactly the way you wish, transforming your idea into the perfect custom made {{ $t('jewelry') }} piece you desire.  <br><br>
            <NuxtLink :to="localePath({ name:'cyo-setting-list-ring'})">Create engagement rings</NuxtLink>, <NuxtLink :to="localePath('/wedding-rings')"> wedding rings</NuxtLink>, <NuxtLink :to="localePath('/fine-jewelry')">fine {{ $t('jewelry') }}</NuxtLink> pieces, family heirloom pieces, personalized gifts, and many more, right from scratch, with eco-friendly, sustainable M <NuxtLink :to="localePath('/lab-diamonds')">lab diamonds</NuxtLink> and a team of committed artisans designing the {{ $t('jewelry') }} piece of your dreams.<br><br>
            We simplify the process by guiding you at every step, making it easy to get the bespoke {{ $t('jewelry') }} you want while staying within your <NuxtLink :to="localePath('/engagement-ring-guide/ring-cost')">set budget</NuxtLink>.</p>
        </div>
        <div class="row mb-5">
            <div class="col-md-6 col-12">
                <div class="steps_guide">
                    <div class="row align-items-center mb-4 pb-2">
                        <div class="col-md-4 col-4">
                            <picture>
                            <source width="109" height="109" type="image/webp" srcset="~/assets/customize/step1.webp">
                            <img width="109" height="109" type="image/jpeg" src="~/assets/customize/step1.jpg" alt="Customize Your Jewelry step one">
                            </picture>
                        </div>
                        <div class="col-md-8 col-8">
                            <h4>Step 1</h4>
                            <p class="mb-0" v-if="$country.is_india">Share reference images and discuss design options with our bespoke {{ $t('jewelry') }} specialist.</p>
                            <p class="mb-0" v-else>Share reference images and discuss design options, with our bespoke {{ $t('jewelry') }} specialist.</p>
                        </div>
                    </div>
                    <div class="row align-items-center mb-4 pb-2">
                        <div class="col-md-4 col-4">
                            <picture>
                            <source width="109" height="109" type="image/webp" srcset="~/assets/customize/step2.webp">
                            <img width="109" height="109" type="image/jpeg" src="~/assets/customize/step2.jpg" alt="Customize Your Jewelry step two">
                            </picture>
                        </div>
                        <div class="col-md-8 col-8">
                            <h4>Step 2</h4>
                            <p class="mb-0">Discuss budget and receive a complimentry price quotation for your custom design.</p>
                        </div>
                    </div>
                    <div class="row align-items-center mb-4 pb-2">
                        <div class="col-md-4 col-4">
                            <picture>
                            <source width="109" height="109" type="image/webp" srcset="~/assets/customize/step3.webp">
                            <img width="109" height="109" type="image/jpeg" src="~/assets/customize/step3.jpg" alt="Customize Your Jewelry step three">
                            </picture>
                        </div>
                        <div class="col-md-8 col-8">
                            <h4>Step 3</h4>
                            <p class="mb-0">Review your design in 3D CAD models and make alterations to the design until you're satisfied.</p>
                        </div>
                    </div>
                    <div class="row align-items-center mb-4 pb-2">
                        <div class="col-md-4 col-4">
                            <picture>
                            <source width="109" height="109" type="image/webp" srcset="~/assets/customize/step4.webp">
                            <img width="109" height="109" type="image/jpeg" src="~/assets/customize/step4.jpg" alt="Customize Your Jewelry step four">
                            </picture>
                        </div>
                        <div class="col-md-8 col-8">
                            <h4>Step 4</h4>
                            <p class="mb-0" v-if="$country.is_india">Watch your design come to life and own the bespoke {{ $t('jewelry') }} piece of your dreams!</p>
                            <p class="mb-0" v-else>Watch your design come to life and own the bespoke {{ $t('jewelry') }} piece of your dreams!</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="for_desktop">
                    <h3 class="font-active">
                        {{ $t('customize') }} Your {{ $t('jewelry') }}
                    </h3>
                    <h2 class="mb-4">You Inspire, We Design!</h2>
                    <p class="mb-0">
                        <span class="ucfirst">{{ $t('customize') }}</span> {{ $t('jewelry') }} at Friendly Diamonds and bring your dream {{ $t('jewelry') }} design to life. Our teams of expert craftsmen create your bespoke {{ $t('jewelry') }} exactly the way you wish, transforming your idea into the perfect custom-made {{ $t('jewelry') }} piece you desire.
                        <br><br>
                        <NuxtLink :to="localePath({ name:'cyo-setting-list-ring'})">Create engagement rings</NuxtLink>, <NuxtLink :to="localePath('/wedding-rings')"> wedding rings</NuxtLink>, <NuxtLink :to="localePath('/fine-jewelry')">fine {{ $t('jewelry') }}</NuxtLink> pieces, family heirloom pieces, personalised gifts, and many more, right from scratch, with eco-friendly, sustainable <NuxtLink :to="localePath('/lab-diamonds')">lab diamonds</NuxtLink> and a team of committed artisans designing the {{ $t('jewelry') }} piece of your dreams.
                        <br><br>
                        We simplify the process by guiding you at every step, making it easy to get the bespoke {{ $t('jewelry') }} you want while staying within your <NuxtLink :to="localePath('/engagement-ring-guide/ring-cost')">set budget</NuxtLink>.
                        <br><br>
                        Begin your {{ $t('customize') }}d {{ $t('jewelry') }} online experience and create your custom-made {{ $t('jewelry') }} today!
                    </p>
                   
                </div>
                <CustomizeForm />
            </div>
        </div>
        <FaqDynamicFaq />
        
    </div>
</template>

<script setup>
   const localePath = useLocalePath();
   const { $country } = useNuxtApp();
   useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>

<style scoped>
.banner{
    margin-bottom: 5%;
}
.steps_guide {
    width: 65%;
    margin-top: 18%;
}
.steps_guide h4 {
    font-size: 18px;
    font-weight: 600;
    text-align: left;
}
.steps_guide p {
    color: #6a6161;
    font-size: 16px;
}
h1, h3 {
    font-size: 40px;
    text-transform: capitalize;
}
h2 {
    font-size: 16px;
    font-weight: 600;
}
p {
    color: #6a6161;
    font-size: 16px;
    font-weight: 500;
}
p a {
    text-decoration: underline;
}

.steps_guide img {
    border-radius: 50%;
}
@media(max-width: 992px){
    .steps_guide {
        width: 95%;
        margin-top: 18%;
    }
    h1, h3 {
        font-size: 32px;
    }  
}
@media (min-width: 768px){
    .steps_guide{
        position: sticky;
        top: 30px;
        height: -webkit-fit-content;
        height: -moz-fit-content;
        height: fit-content;
    }
}
@media(max-width: 767px){
    .steps_guide{
        width: 100%;
    }
    .steps_guide p{
        color: #6a6161;
        font-size: 16px;
    }
    .steps_guide p {
        color: #6a6161;
        font-size: 13px;
        text-align: left;
    }
    h1, h3 {
        font-size: 32px;
        text-align: center;
        margin-top: 10%;
    } 
    h2, p{
        text-align: center;
    }
}
</style>
